import request from 'api/requestUtils'
import { baseUri } from './utils'

interface CartStatusPatchItem {
  itemId: number
  cartExcluded?: boolean
  cartItemId?: string | null
  isBooked?: boolean
  confirmationCode?: string | null
}

interface CartStatusResponse {
  result: { updated: number }
}

export async function patchCartItemStatus(
  chatId: number,
  items: Array<CartStatusPatchItem>,
): Promise<void> {
  await request.patch<CartStatusResponse, { items: Array<CartStatusPatchItem> }>(
    `${baseUri}/v3/chats/${chatId}/items/cart-status`,
    { items },
    { credentials: 'include' },
  )
}
